module.exports = __webpack_public_path__ + "static/assets/f63ed476e56f3e759ebe65213e6788a5.svg";